module.exports = __webpack_public_path__ + "img/chart-line-icon.3cf726cb.svg";